import * as React from 'react'

import { action, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import DesktopEventStore from '~/client/src/desktop/stores/EventStore/DesktopEvents.store'
import DeliveriesListStore from '~/client/src/desktop/views/Deliveries/components/DeliveriesList/DeliveriesList.store'
import DeliveryStatusLabel from '~/client/src/shared/components/DeliveryStatusLabel/DeliveryStatusLabel'
import { Content, Footer, View } from '~/client/src/shared/components/Layout'
import {
  Radio,
  RadioGroup,
} from '~/client/src/shared/components/shadcn-ui/radio-group'
import DeliveryStatus from '~/client/src/shared/constants/DeliveryStatus'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ActionHandleButton from '../ActionHandleButton/ActionHandleButton'
import DeliveryBulkUpdaterStore from './DeliveryBulkUpdater.store'

// localization: translated

interface IProps {
  deliveriesListStore: DeliveriesListStore
  onUpdated: () => void
  eventsStore?: DesktopEventStore
}

const DISPLAYED_STATUSES = [
  DeliveryStatus.Requested,
  DeliveryStatus.Scheduled,
  DeliveryStatus.OnSite,
  DeliveryStatus.PassedInspection,
  DeliveryStatus.FailedInspection,
  DeliveryStatus.IncompleteDone,
  DeliveryStatus.Done,
  DeliveryStatus.Denied,
  DeliveryStatus.Canceled,
]

@inject('eventsStore')
@observer
export default class DeliveryBulkUpdater extends React.Component<IProps> {
  private readonly store: DeliveryBulkUpdaterStore = null

  public constructor(props: IProps) {
    super(props)

    this.store = new DeliveryBulkUpdaterStore(
      props.eventsStore,
      props.deliveriesListStore,
      props.onUpdated,
    )
    makeObservable(this)
  }

  public render() {
    const { handleUpdate, selectedStatus, canUpdateSelectedBulk } = this.store
    const canUpdate = canUpdateSelectedBulk(selectedStatus)

    return (
      <View>
        <Content className="relative pa20 no-outline-container">
          <RadioGroup
            className="tw:flex tw:flex-col tw:gap-2"
            value={selectedStatus}
            onValueChange={this.handleValueChange}
          >
            {this.renderRadios()}
          </RadioGroup>
        </Content>
        <Footer className="row pb10 pt12 px12">
          <ActionHandleButton
            title={this.actionHandleButtonTitle}
            onClick={handleUpdate}
            isEnabled={canUpdate}
          />
        </Footer>
      </View>
    )
  }

  private get actionHandleButtonTitle(): string {
    const { filteredDeliveries } = this.store
    return Localization.translator.updateXDeliveries(filteredDeliveries.length)
  }

  private renderRadios() {
    const { canUpdateSelectedBulk } = this.store

    return DISPLAYED_STATUSES.map((status, key) => {
      const isInactive = !canUpdateSelectedBulk(status)
      return (
        <label
          key={key}
          className={classList({
            'tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none': true,
            'tw:opacity-50 tw:pointer-events-none': isInactive,
          })}
        >
          <Radio value={status} disabled={isInactive} />
          <DeliveryStatusLabel status={status} />
        </label>
      )
    })
  }

  @action.bound
  private handleValueChange(value: string) {
    this.store.selectedStatus = value as DeliveryStatus
  }
}
